import { css } from 'styled-components';

export const RichTextBaseStyle = css`
  --textHighlightSecondary: currentColor;
  // --textHighlightColor
  // --textHighlightSecondaryOpacity

  strong {
    font-weight: 600;
  }

  a {
    position: relative;
    color: var(--textHighlightColor);

    &::after {
      content: '';
      position: absolute;
      border-bottom-width: 1px;
      border-bottom-style: solid;
      border-bottom-color: var(--textHighlightSecondary);
      opacity: var(--textHighlightSecondaryOpacity);
      bottom: -3px;
      left: 0;
      right: 0;
      pointer-events: none;
    }

    &:hover,
    &:focus {
      &::after {
        border-bottom-width: 2px;
      }
    }
  }

  ul {
    list-style-type: '- ';
    list-style-position: inside;
  }
`;
